/*
 * Copyright (c) 2022
 * This file is part of the Compo B2B application.
 * Compo soft - Grigory Miroshnichenko <grinderspro@gmail.com>
 * For the full copyright and license information, please view
 * the LICENSE file that was distributed with this source code.
 */

import {FlatTreeControl} from '@angular/cdk/tree';
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbMenuItem,
  NbOptionModule,
  NbSelectModule,
  NbSpinnerModule,
  NbWindowRef
} from '@nebular/theme';
import {
  BaseComponent,
  Catalog,
  CompoTreeComponent,
  Contract,
  ContractService,
  Customer,
  CustomerGroup,
  FileService,
  LazyCatalog,
  StoreService
} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {catchError, map, shareReplay, take, takeUntil, tap} from 'rxjs/operators';
import {CustomerDynamicDataSource} from '../../catalog/modal-catalog/customer-dynamic-data-source';
import {CustomerCatalogService} from '../../catalog/services/customer-catalog.service';
import {AsyncPipe, NgClass} from '@angular/common';
import {TuiIcon} from '@taiga-ui/core';

interface MenuItemWithLevel extends NbMenuItem {
  level?: number;
  children?: MenuItemWithLevel[];
}

@Component({
  selector: 'app-modal-export',
  templateUrl: './modal-excel-export.component.html',
  styleUrls: ['./modal-excel-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbCardModule, FormsModule, ReactiveFormsModule, NbSelectModule, NbOptionModule, NbCheckboxModule, CompoTreeComponent, NgClass, TuiIcon, NbButtonModule, NbSpinnerModule, AsyncPipe]
})
export class ModalExcelExportComponent extends BaseComponent implements OnInit {

  treeControl: FlatTreeControl<LazyCatalog>;
  dataSource: CustomerDynamicDataSource;
  data1: LazyCatalog[] = [];
  catalogId = '';

  @Input() items: MenuItemWithLevel[];

  submitted = false;
  availableProductSelect = false;
  actionProductSelect = false;
  recommendedProductSelect = false;
  addPictureProducts = false;
  catalogCheckedIds: Array<number> = [];
  catalogs: Catalog[] = [];
  customer: Customer;
  params: string[] = [];
  catalogsRoot$: Observable<Catalog[]>;
  public title: string;
  private region: number | null = null;
  contracts$: Observable<Contract[]>;
  selectedContract: Contract;
  contracts: Contract[];
  queuIsEmpty: boolean = true;

  inputForm = new FormGroup({
    contract: new FormControl(null, Validators.required),
    availableProductSelect: new FormControl(this.availableProductSelect),
    actionProductSelect: new FormControl(this.actionProductSelect),
    recommendedProductSelect: new FormControl(this.recommendedProductSelect),
    addPictureProducts: new FormControl(this.addPictureProducts),
  });

  readonly customerGroup$ = this.storeService.getCustomerGroup();

  constructor(private readonly windowRef: NbWindowRef,
              private readonly storeService: StoreService,
              private readonly catalogService: CustomerCatalogService,
              protected readonly contractService: ContractService,
              protected readonly fileService: FileService) {
    super();
  }

  private initCatalogTree() {
    this.catalogId = undefined;
    this.catalogsRoot$ = this.compoApiService.get<Catalog[]>('/catalog/tree').pipe(map(response => response.data));

    this.catalogService.initCatalogTree()
      .pipe(take(1), catchError(err => this.handleError(err)))
      .subscribe(tree => {
        if (this.catalogId === undefined) {
          this.data1 = tree;
          console.log(this.data1);
        } else {
          const listOfRoot = tree.filter(item => item.parentId == 1);
          this.data1 = listOfRoot;
          this.catalogService.treeRecursion(tree, listOfRoot);
        }
        this.cdr.detectChanges();
      });
  }

  ngOnInit(): void {
    this.initCatalogTree();

    // this.compoApiService.get<boolean>('/product/price-list/queue-is-empty')
    //   .pipe(
    //     map(response => response.data),
    //     take(1),
    //     catchError(_ => {
    //       this.queuIsEmpty = true;
    //       this.cdr.detectChanges();
    //       return EMPTY;
    //     })
    //   )
    //   .subscribe(
    //     result => this.queuIsEmpty = result
    //   );

    this.customer = this.windowRef.config.context as Customer;
    this.makeRegionByCustomerGrout(this.customer.customerGroup);

    this.contracts$ = this.contractService.getAll().pipe(
      map(response => response.data),
      tap(response => {
        this.contracts = response;
        this.selectedContract = this.contracts[0];
      }),
      tap(contracts => this.setDefaultSelectedContract(contracts)),
      shareReplay()
    );
  }

  setDefaultSelectedContract(contracts: Contract[]): void {
    if (contracts.length > 0) {
      this.inputForm.controls['contract'].setValue(contracts[0].id);
      this.cdr.detectChanges();
    }
  }

  categoryChecked(catalogId: number, event) {
    if (!event) {
      this.catalogCheckedIds = this.catalogCheckedIds.filter(item => item !== catalogId);
    } else {
      this.catalogCheckedIds.push(catalogId);
    }
  }

  onSubmit() {

    this.submitted = true;
    this.makeParams();
    console.log(this.availableProductSelect);

    const data = {
      contractId: this.inputForm.controls['contract'].value,
      catalogIds: this.catalogIdsArrayToString(this.catalogCheckedIds),
      catalogCheckedIds: this.catalogCheckedIds,
      region: this.region,
      params: this.makeParams()
    };

    console.log(data.contractId);

    this.exportToXls(data);

  }

  private makeParams(): { [key: string]: boolean } {
    const tagCounts: { [key: string]: boolean } = {};
    tagCounts.productAvailable = !!this.availableProductSelect;
    tagCounts.actionProductSelect = !!this.actionProductSelect;
    tagCounts.recommendedProductSelect = !!this.recommendedProductSelect;
    tagCounts.addPictureProducts = !!this.addPictureProducts;
    return tagCounts;
  }

  private catalogIdsArrayToString(catalogIds: Array<number>): string {
    let result = '';
    if (catalogIds.length <= 0) {
      return result;
    }
    catalogIds.forEach(element => result = result + element + ',');
    result = result.replace(/,$/gi, '');
    return result;
  }

  exportToXls(data) {
    this.fileService.downloadPostUrl('/product/price-list/export', data)
      .pipe(
        tap((response: Blob) => {
          this.handleDownloadResponse(response, 'ProductsList.xlsx')
        }),
        take(1),
        catchError(err => this.handleError(err)),
      ).subscribe();
  }

  handleDownloadResponse(response: Blob, name: string) {
    this.submitted = false;
    this.cdr.detectChanges();
    if (response.size !== 0) {
      FileService.saveAs(response, name);
    }
  }

  private makeRegionByCustomerGrout(customerGroup: CustomerGroup) {
    this.region = customerGroup?.id;
  }

  close() {
    this.windowRef.close();
  }

  public tree(category: Catalog) {
    this.catalogService.getLazyChildren(category.id).pipe(takeUntil(this.unsubscribe)).subscribe(children => console.log(children));
  }

  public setId(itemId: number) {
    const item = this.catalogService.getParent(this.data1, itemId);
    this.catalogId = String(itemId);

    item.expanded = !item.expanded;
    if (item.children === undefined && item.lastLevel === false) {
      this.catalogService.getLazyChildren(item.id).pipe(
        takeUntil(this.unsubscribe),
      ).subscribe(dataChild => {
        this.catalogService.addChildrenToParentByParentId(item.id, item, dataChild);
        this.cdr.detectChanges();
      });
    }
    this.cdr.detectChanges();

  }

}
